import { createAction } from 'redux-actions';
import {
  PapiRequestDaSharedGiveLlama,
  PapiRequestDaSharedPointsModalGive,
  PapiDaSharedGiveLlama,
  PapiDeviation,
} from '@wix/da-papi-types';
import {
  actionTypePrefix,
  SimpleXHREndpoint,
  SimpleXHRMethod,
} from './constants';

export type SimpleXHRCallbacks = {
  onComplete?: () => void;
  onSuccess?: (response: any) => void;
  onError?: (response?) => void;
};

export const makeGiveLlamaXHRCall = ({
  username,
  onBadgeSent,
  onBadgeError,
}: {
  username: string;
  onBadgeSent?: () => void;
  onBadgeError?: (response: PapiDaSharedGiveLlama) => void;
}) => {
  const data: PapiRequestDaSharedGiveLlama = {
    foruser: username,
  };
  return makeXHRCall({
    endpoint: SimpleXHREndpoint.GIVE_LLAMA,
    method: SimpleXHRMethod.POST,
    data,
    onSuccess: onBadgeSent,
    onError: onBadgeError,
  });
};

export const makeGivePointsXHRCall = ({
  username,
  pointsAmount,
  message,
  ...callbacks
}: {
  username: string;
  pointsAmount: number;
  message?: string | null;
} & SimpleXHRCallbacks) => {
  const data: PapiRequestDaSharedPointsModalGive = {
    recipient_username: username,
    amount: pointsAmount,
    message: message || undefined,
  };
  return makeXHRCall({
    endpoint: SimpleXHREndpoint.GIVE_POINTS,
    method: SimpleXHRMethod.POST,
    data,
    ...callbacks,
  });
};

export const makeInitGivePointsPopupXHRCall = () => {
  return makeXHRCall({
    endpoint: SimpleXHREndpoint.GIVE_POINTS_POPUP,
    method: SimpleXHRMethod.GET,
  });
};

export const makeInitDeviationXHRCall = (deviation: PapiDeviation) => {
  return makeXHRCall({
    papiBase: 'dadeviation',
    endpoint: SimpleXHREndpoint.INIT_DEVIATION,
    method: SimpleXHRMethod.GET,
    params: {
      username: deviation.author?.username,
      deviationid: deviation.deviationId,
      type: 'art',
      include_session: false,
    },
  });
};

export const makeGiveBadgeXHRCall = ({
  username,
  badgeType,
  onBadgeSent,
  onBadgeError,
}: {
  username: string;
  badgeType: string;
  onBadgeSent?: () => void;
  onBadgeError?: (response: any) => void;
}) => {
  const data = {
    foruser: username,
    type: badgeType,
  };
  return makeXHRCall({
    endpoint: SimpleXHREndpoint.GIVE_BADGE,
    method: SimpleXHRMethod.POST,
    data,
    onSuccess: onBadgeSent,
    onError: onBadgeError,
  });
};

export type MakeXHRCallPayload = {
  endpoint: SimpleXHREndpoint;
  method?: SimpleXHRMethod;
  papiBase?: string;
  params?: object;
  data?: any;
} & SimpleXHRCallbacks;

export const makeXHRCall = createAction(
  `${actionTypePrefix}/MAKE_XHR_CALL`,
  (payload: MakeXHRCallPayload) => payload
);

export const setIsLoading = createAction(
  `${actionTypePrefix}/SET_IS_LOADING`,
  (payload: SimpleXHREndpoint) => payload
);

export const storeResult = createAction(
  `${actionTypePrefix}/STORE_RESULT`,
  (payload: { endpoint: SimpleXHREndpoint; result: any }) => payload
);
